export default "__VITE_ASSET__dYWjuanL__"